import React from 'react'
import i18n from 'i18next'
import MetaTags, { DEFAULT_META_TITLE, DEFAULT_SOCIAL_IMAGE, absoluteUrl, canonicalUrl } from '../utils/MetaTags'

/**
 * Site-level social preview tags, emitted on every page.
 *
 * react-helmet-async is the single authority for these tags. The matching tags
 * in public/index.html are marked data-rh="true" so helmet ADOPTS and REPLACES
 * them on mount instead of appending a second set alongside them -- that
 * duplication is what put two og:image tags on the page.
 *
 * Pages with their own record-level metadata (conversations, partners, topics,
 * journeys) render CustomMetaTags deeper in the tree; helmet dedupes by
 * name/property, so the deeper declaration wins over these defaults.
 */
export default function defaultMetaTags(Component) {
  return class DefaultMetaTags extends React.PureComponent {
    render() {
      const description = i18n.t('meta.defaultDescription')

      return (
        <div>
          <MetaTags>
            <title>{DEFAULT_META_TITLE}</title>
            <meta name='description' content={description} />
            <meta property='og:title' content={DEFAULT_META_TITLE} />
            <meta property='og:description' content={description} />
            <meta property='og:image' content={absoluteUrl(DEFAULT_SOCIAL_IMAGE)} />
            <meta property='og:url' content={canonicalUrl()} />
            <meta name='twitter:card' content='summary_large_image' />
          </MetaTags>

          <Component {...this.props} />
        </div>
      )
    }
  }
}
